/**
 * append-utm.js
 *
 * 给带 `data-append-utm-term="true"` 的 <a> 链接:
 *   - 点击时把当前浏览器 URL 的 utm_term 参数拼接到 href 后面
 *
 * 给带 `data-boa-track-cta="true"` 的 <a> 链接:
 *   - 点击时触发 window.luteTrack('boa_click_amazon', { link_url, outbound_channel }) 埋点
 *
 * 行为:
 *   - 仅匹配对应 data-attribute 时才生效
 *   - utm_term 拼接: 当前页面 URL 没 utm_term / href 为空或 # / href 已含 utm_term
 *     → 跳过,不影响原始行为
 *   - 用 capture phase 在其他 click handler 之前执行,
 *     保证 target="_blank"、middle-click、ctrl-click 都能读到新 href
 */
;(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function getUtmTerm() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('utm_term') || '';
    } catch (e) {
      var match = String(window.location.search || '').match(/[?&]utm_term=([^&]*)/);
      return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
    }
  }

  function appendUtmTerm(href, utmTerm) {
    if (!utmTerm || !href) return href;
    try {
      var url = new URL(href, window.location.origin);
      if (url.searchParams.has('aa_creativeid')) return href;
      url.searchParams.append('aa_creativeid', utmTerm);
      return url.toString();
    } catch (e) {
      var sep = href.indexOf('?') >= 0 ? '&' : '?';
      return href + sep + 'aa_creativeid=' + encodeURIComponent(utmTerm);
    }
  }

  function fireCtaTrack(link) {
    if (typeof window.luteTrack !== 'function') return;
    try {
      console.log('fireCtaTrack', link);
      window.luteTrack('boa_click_amazon', {
        link_url: (link && link.getAttribute('href')) || '',
        outbound_channel: 'amazon'
      });
    } catch (e) {
      /* swallow — 埋点失败不应阻塞点击 */
    }
  }

  function handleClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var link = target.closest('a[data-append-utm-term="true"], a[data-boa-track-cta="true"]');
    if (!link) return;

    // 1) CTA 埋点
    if (link.matches('a[data-append-utm-term="true"], a[data-boa-track-cta="true"]')) {
      fireCtaTrack(link);
    }

    // 2) utm_term 拼接
    if (!link.matches('a[data-append-utm-term="true"]')) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    var utmTerm = getUtmTerm();
    if (!utmTerm) return;
    var newHref = appendUtmTerm(href, utmTerm);
    if (newHref !== href) {
      link.setAttribute('href', newHref);
    }
  }

  function bind() {
    document.addEventListener('click', handleClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
